// extracted by mini-css-extract-plugin
export default {"tabsContainer":"EditSidebarTabs_tabsContainer__jcKCT","tab":"EditSidebarTabs_tab__Nm2eZ","activeTab":"EditSidebarTabs_activeTab__8u0op"};